import { composeWithDevTools } from '@redux-devtools/extension'
import { applyMiddleware, legacy_createStore as createStore } from 'redux'
import thunk from 'redux-thunk'
import { IAction, IAppState, TAppStore } from '~/shared/store/types'

import { rootReducer } from './rootReducer'

export const store: TAppStore = createStore<IAppState, IAction<any>, any, any>(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk)),
)
